module.exports = __webpack_public_path__ + "img/Profile-Picture.f5e09eba.jpg";